import { render } from "./FormInterestsView.vue?vue&type=template&id=1baef445"
import script from "./FormInterestsView.vue?vue&type=script&lang=js"
export * from "./FormInterestsView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Ralph/repos/verduurzamen/quickcheck/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__